module.exports = __webpack_public_path__ + "img/download-btn.1f5435ac.png";